import { render } from "./GlobesPage.vue?vue&type=template&id=37b42bd0&scoped=true"
import script from "./GlobesPage.vue?vue&type=script&lang=js"
export * from "./GlobesPage.vue?vue&type=script&lang=js"

import "./GlobesPage.vue?vue&type=style&index=0&id=37b42bd0&scoped=true&lang=css"

import exportComponent from "/Users/gareth/Documents/Maps/Projects/globes-that-were/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37b42bd0"]])

export default __exports__